<template>
  <a-card :bordered="false">
    <a-tabs :activeKey="activeKey" @change="callback">
      <a-tab-pane tab="条件查询开票" key="1">
        <biz-direct-invoice-query ref="queryTab"></biz-direct-invoice-query>
      </a-tab-pane>
      <a-tab-pane tab="导入开票" key="2">
        <biz-direct-invoice-import ref="importTab"></biz-direct-invoice-import>
      </a-tab-pane>
      <a-tab-pane :tab="'最终开票列表' + (invoiceCount > 0 ? ' (' + invoiceCount + ')' : '')" key="3">
        <biz-direct-invoice-list ref="listTab"></biz-direct-invoice-list>
      </a-tab-pane>
      <a-tab-pane tab="发票推送" key="4">
        <biz-invoiceinfo-send-list ref="invoiceTab" :key="invoiceTabKey" :queryParams="invoiceQueryParams" editScene="directinvoice"></biz-invoiceinfo-send-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BizDirectInvoiceQuery from './BizDirectInvoiceQuery'
  import BizDirectInvoiceImport from './BizDirectInvoiceImport'
  import BizDirectInvoiceList from './BizDirectInvoiceList'
  import BizInvoiceinfoSendList from './BizInvoiceinfoSendList'

  export default {
    name: 'BizDirectInvoice',
    components: {

      BizDirectInvoiceQuery,
      BizDirectInvoiceImport,
      BizDirectInvoiceList,
      BizInvoiceinfoSendList
    },
    computed: {
      ...mapGetters('invoice', ['invoiceCount'])
    },
    data() {
      return {
        activeKey: '1',
        invoiceQueryParams: {},
        invoiceTabKey: 0
      }
    },
    mounted() {
      this.$root.$on('import-success', (data) => {
        this.$refs.importTab.$parent.$refs.queryTab.loadData(1)
      })
      // 监听跳转到发票推送页面的事件
      this.$root.$on('go-to-invoice-send', (dateRange) => {
        // 先切换tab
        this.activeKey = '4'
        // 延迟设置查询条件，确保组件已渲染
        this.$nextTick(() => {
          // 强制重新渲染组件
          this.invoiceTabKey++
          // 设置查询条件为未推送状态
          this.invoiceQueryParams = {
            status: '0'
          }
        })
      })
    },
    beforeDestroy() {
      this.$root.$off('import-success')
      this.$root.$off('go-to-invoice-send')
    },
    methods: {
      callback(key) {
        this.activeKey = key
      }
    }
  }
</script>
